const segments = {
  ai_builder: {
    page_title: 'SegmentAI',
    modal_title: 'Create Segment with AI',
    back_button: 'Back',
    saving: 'Saving...',
    save_segment: 'Save Segment',
    header: {
      ai_label: 'AI',
      ask_thanx_to_build: 'Ask Thanx to build it',
      cancel: 'Exit',
    },
    empty_state: {
      title: 'Create a new segment',
      subtitle: 'Describe your desired segment',
      placeholder:
        'i.e. Target customers who made 3 or more purchases in the last two weeks.',
      suggestion_1: 'Which attributes are available for targeting?',
      suggestion_2:
        'Target customers who have made a purchase at my locations in ...',
      suggestion_3:
        'Target customers who spent over $300 in the last 12 months but have not made a purchase in the last 30 days.',
      submit_text: 'Create Segment',
      help_intro: 'Still have questions?',
      help_text: 'Need help with segments?',
      help_link_support: 'Contact Support',
      help_link_text: 'Shape how Segment AI works for you →',
      help_link_1_text: 'What attributes you can target',
      help_link_2_text: 'Learn more about creating segments using AI',
      help_link_action_text: 'Share Feedback',
      aria_label_main: 'SegmentAI',
      aria_label_form: 'Create segment form',
    },
    conversation: {
      reply_placeholder: 'Reply to ThanxAI...',
      connection_error:
        'Unable to connect to AI chat. Please refresh the page.',
      connecting: 'Connecting to AI chat...',
      connected: 'Connected to AI chat',
    },
  },
  ai_prompt: {
    aria_label_suggestion: 'Use suggestion: %{suggestion}',
    suggestions_help_text:
      'Select one of the following suggestions to fill the input field:',
  },
  landing: {
    all_segments: 'All segments',
    create_new_segment: 'Create a new segment',
    fetch_error: 'Failed to load segments. Please try again.',
    empty: 'No segments',
    modal: {
      request_segment: {
        title: 'Request a new custom segment',
        subtitle:
          "Fill out the form to tell us which customers you want to target. We'll work with you to create a custom segment.",
      },
    },
    new_segment_campaign_modal: {
      errors: {
        no_segment: 'No segment selected',
        submit: 'Failed to create campaign',
      },
    },
    other: 'Other',
    page_title: 'Segments',
    table: {
      create_campaign: 'Create a campaign',
      name: 'Name',
    },
    title: 'Segments',
    search_placeholder: 'Search segments by name',
    total_loyalty_members: 'Total loyalty members',
    total_loyalty_members_popover: 'All the loyalty members in your database',
    total_users: 'Total customers in your database',
    total_users_popover: 'All the customers in your database',
    type_filter: {
      all: 'Pre-built and Custom segments',
      merchant: 'Custom segments only',
      global: 'Pre-built segments only',
    },
  },
  details: {
    // Accessible name for the spinner shown in the tab content region while the
    // segment is still loading.
    loading: 'Loading segment details',
    tabs: {
      summary: 'Summary',
      segment_rules: 'Segment Rules',
      sample_customers: 'Sample Customers',
      navigation_label: 'Segment details tabs',
    },
    summary: {
      customer_behavior: 'Customer behavior',
      description_title: 'Description',
      description: "This segment doesn't have a description.",
      when_used_as_automation_title: 'When used as an automation',
      when_used_as_automation:
        'This segment continuously monitors for any customer with one or more purchases precisely 30d prior (to the minute) whenever it is run who has not made a subsequent purchase as of the moment the segment is refreshed. Once a customer enters this segment, your automation will send the configured campaign to them.',
      when_used_as_one_time_title: 'When used as a one-time campaign',
      when_used_as_one_time:
        'A one-time campaign will send to all customers who are presently in the segment at the moment it is scheduled to send.',
    },
    segment_rules: {
      title: 'Segment rules',
      coming_soon: 'Segment rules details coming soon',
      loading_visualization: 'Loading segment rules visualization...',
      visualization_error: 'Unable to display segment rules visualization',
      no_rules: 'No segment rules available',
    },
    sample_customers: {
      title: 'Sample customers',
      customer_count:
        'Showing a sample from the %{count} customers currently in this segment',
      lifetime_spend: 'Lifetime spend',
      days_since_last_visit: 'Days since last visit',
      days_count: '%{days} days',
      not_available: 'N/A',
      loyalty_tier: 'Loyalty tier',
      no_tier: 'No tier',
      view_profile: 'View profile',
      empty_state: 'No sample customers available',
      load_error: 'Unable to load sample customers',
      coming_soon: 'Sample customers list coming soon',
      loading_message: 'Loading sample customers...',
      load_more: 'Loading more customers...',
    },
  },
  segment_page: {
    created_by_with_ai: 'Created by %{creator_name} with ThanxAI on %{date}',
    created_by: 'Created by %{creator_name} on %{date}',
    created_with_ai: 'Created with AI on %{date}',
    created_on: 'Created on %{date}',
    created_by_with_ai_no_date: 'Created by %{creator_name} with ThanxAI',
    created_by_no_date: 'Created by %{creator_name}',
    page_title: '%{segment_name} - Segments - Thanx',
    create_campaign_button: 'Create a campaign',
  },
}

export default segments
